import { render, staticRenderFns } from "./RELKpisEnderecosExternos.vue?vue&type=template&id=9c744372&scoped=true&"
import script from "./RELKpisEnderecosExternos.vue?vue&type=script&lang=js&"
export * from "./RELKpisEnderecosExternos.vue?vue&type=script&lang=js&"
import style0 from "./RELKpisEnderecosExternos.vue?vue&type=style&index=0&id=9c744372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c744372",
  null
  
)

export default component.exports